import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Text/BBHeading';
import Webform from '../../Webform';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBWebform = ({ webform, behaviorSettings = null, reCaptchaEnabled }) => (
  <div
    className={`bb bb-webform ${styles['bb-webform']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
  >
    <Heading title={webform.title} Tag="h2" />
    <Webform webform={webform} reCaptchaEnabled={reCaptchaEnabled} />
  </div>
);

BBWebform.propTypes = {
  webform: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        field_id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    ).isRequired,
    successType: PropTypes.oneOf(['redirect', 'message']).isRequired,
    successMessage: PropTypes.string.isRequired,
    successUrl: PropTypes.string.isRequired,
  }).isRequired,
  behaviorSettings: behaviorSettingsProps,
  reCaptchaEnabled: PropTypes.bool.isRequired,
};

export default BBWebform;
